import { Typography } from "@altimateai/lego";
import { useAppState } from "@/modules/app/useAppContext";
import useFiltersBySearchParams from "@/helpers/useFiltersBySearchParams";
import { PreSelectFilters } from "./filters";
import { ExplorerFiltersDropdown } from "./ExplorerFiltersDropdown";
import styles from "../styles.module.scss";

export const ExplorerHeader = () => {
  // Both tenant flags are consumed here: `isDatabricksTenant` hides
  // Snowflake-specific quick filters; `enablePriorityTab` gates the
  // tenant-flag-driven Priority tab.
  const { loggedinUser, isDatabricksTenant, enablePriorityTab } = useAppState();
  const { searchParams } = useFiltersBySearchParams();
  const priorityTabEnabled = enablePriorityTab ?? false;
  // Default tab is Priority when the flag is enabled — keep this in sync
  // with `ExplorerTabs` and `ExplorerContentOriginal` so the filter
  // chips/dropdown are hidden on first visit too (not just after the
  // user manually clicks Priority).
  const tab = searchParams.get("tab") || (priorityTabEnabled ? "priority" : "opportunities");

  const onPriorityTab = tab === "priority";

  // The predefined quick filters target Snowflake opportunity types
  // (dormant tables, big-warehouse copies, remote spillage) — not relevant
  // on Databricks tenants or on the Groups tab. Visible on Opportunities
  // and Priority tabs for Snowflake tenants.
  const showPreSelectFilters = (tab === "opportunities" || onPriorityTab) && !isDatabricksTenant;

  return (
    <>
      <Typography variant="page-heading">Discover</Typography>
      <div className={styles.filters}>
        {/* Spacer pushes the filter dropdowns to the right whenever the
            left-hand quick filters are absent — covers Groups tab and
            Databricks tenants (where Snowflake-only quick filters are
            hidden across every tab). */}
        {!showPreSelectFilters && <div className="al-flex-1" />}
        {showPreSelectFilters && (
          <div className={styles.preSelect}>
            <PreSelectFilters currentUser={loggedinUser} />
          </div>
        )}
        {/* Priority shows the full filter bar — preset quick-filters,
            Filter By, Saved Filters, and the date range all apply to the
            priority list (worst case they narrow it to zero, which is fine).
            Column picker stays on since Priority is a detailed table. */}
        <ExplorerFiltersDropdown
          showColumnPicker={tab === "opportunities" || onPriorityTab}
          showFilters
        />
      </div>
    </>
  );
};
